<template>
  <div>
    <div class="bannerTemp">
      <div class="module">
        <div class="title">{{data.title}}</div>
        <div class="p" v-html="data.p"></div>
      </div>
    </div>
    <div class="mobile-bannerTemp">
      <div class="banner-content">
        <div class="title">{{data.title}}</div>
        <div class="line"></div>
        <div class="p" v-html="data.p" :style="{ width: computedWidth }" ></div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'bannerTemp',
  props: {
    data: Object,
    isLong: {
      type: Boolean,
      default: false 
    }
  },
  computed: {
    computedWidth() {
      return this.isLong ? '24rem' : '16.5rem';
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.bannerTemp {
  height: 430px;
  .module {
    overflow: hidden;
    .title {
      font-size: 50px;
      color: rgba(255, 255, 255, 1);
      line-height: 70px;
      margin: 150px 0 40px 0;
    }
    .p {
      width: 480px;
      font-size: 20px;
      color: rgba(255, 255, 255, 1);
      line-height: 28px;
    }
  }
}
.mobile-bannerTemp {
  display: none;
  width: 100%;
  height: 28rem;
  .banner-content {
    overflow: hidden;
    box-sizing: border-box;
    padding-left: 2rem;
    .title {
      font-size: 1.8rem;
      margin-top: 8rem;
      color: rgba(255, 255, 255, 1);
      font-weight: bold;
      line-height: 3rem;
    }
    .line {
      width: 4rem;
      height: 0.2rem;
      background: #FFFFFF;
      margin-top: 1rem;
    }
    .p {
      
      font-size: 1rem;
      font-weight: 350;
      line-height: 1.6rem;
      margin-top: 3rem;
      color: rgba(255, 255, 255, 1);
    }
  }
}
@media (max-width: 1024px) {
  .bannerTemp {
    display: none !important;
  }
  .mobile-bannerTemp { 
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/templates/bannerTemp.vue